export const CLEANER_SENTRY_DSN = process.env.REACT_APP_CLEANER_SENTRY_DSN;
export const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;
export const CLEANER_WEB_APP_URL = process.env.REACT_APP_CLEANER_WEB_APP_URL || "https://cleaner.realtycalendar.ru";
